import '.a6{position:absolute;}.ssr-plugin'
import '.b9{inset:0px;}.ssr-plugin'
import '.ba{object-fit:cover;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.k{height:100%;}.ssr-plugin'
import '.bb{z-index:0;}.ssr-plugin'
import '.bc{height:80vh;}.ssr-plugin'
import '.bd{bottom:0px;}.ssr-plugin'
import '.ag{left:0px;}.ssr-plugin'
import '.be{right:0px;}.ssr-plugin'
import '.bf{margin-bottom:32px;}.ssr-plugin'
import '.ai{position:relative;}.ssr-plugin'
import '.bg{opacity:0;}.ssr-plugin'
import '.bh{animation:winner-title-slide-in 0.6s ease-out forwards;}.ssr-plugin'
import '.bi{max-width:480px;}.ssr-plugin'
import '.at{opacity:0.5;}.ssr-plugin'
import { styled } from 'inlines'
import { Layout } from '../components/Layout.js'
import { useTrack } from '../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../shared/analyticsEvents.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { colors } from '../utils/colors.js'
import { TABLET, MOBILE } from '../utils/breakpoints.js'
import { useContentQuery } from '../ctx.js'
import { useEffect } from 'react'

export const WinnerPage = ({ title, description, contestants }) => {
  const track = useTrack('winner')

  const { data: winnerName } = useContentQuery('winner')

  const winnerContestant = contestants?.find(
    (c: { name: string }) => c.name === winnerName,
  )

  const winnerImage = winnerContestant?.image?.src

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD)
  }, [])

  return (
    <>
      {winnerImage && (
        <img className="a6 b9 ba m k bb"
          src={winnerImage}
        />
      )}
      <div className="bc a6 m bd ag be bb"
        style={{
          background: `linear-gradient(0deg, ${transparentColor(colors.secondary, 1)} 0%, ${transparentColor(colors.secondary, 0)} 100%)`,}}
      />
      <Layout
        style={{
          justifyContent: 'flex-end',
          position: 'relative',
          [TABLET]: {
            paddingBottom: '48px',
          },
          [MOBILE]: {
            padding: '16px',
            paddingBottom: '24px',
          },
        }}
      >
        <style>{`
          @keyframes winner-title-slide-in {
            from { opacity: 0; transform: translateY(48px); }
            to   { opacity: 1; transform: translateY(0); }
          }
        `}</style>
        {/* <styled.h1
          style={{
            marginBottom: 24,
            position: 'relative',
            opacity: 0,
            animation: 'winner-title-slide-in 0.6s ease-out 0.2s forwards',
            color: `${colors.primary}`,
            [TABLET]: {
              marginBottom: '24px',
            },
          }}
        >
          {winnerName ?? ''}
        </styled.h1> */}
        <h3 className="bf ai bg bh"
        >
          {title
            ?.replace('{{WINNER}}', winnerName ?? '')
            .replace('{{YEAR}}', '2026')}
        </h3>

        <p className="bi at">
          {description}
        </p>
      </Layout>
    </>
  )
}
